<template>
    <div>
        <modal v-model="dentalPlanModal" :title="titleDentalPlanModal" @hide="resetDentalPlanModal">
            <div class="row">
                <div class="col-lg-4">
                    <div :class="[$v.dentalPlan.code.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Código</label>
                        <input type="text" class="form-control" v-model="dentalPlan.code">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div :class="[$v.dentalPlan.name.required ? '' : 'has-error', 'form-group']">
                        <label class="control-label">Nome</label>
                        <input type="text" class="form-control" v-model="dentalPlan.name">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label class="control-label">Tabela de preços</label>
                        <multiselect v-model="dentalPlan.price_list" id="ajax" label="name" track-by="id" placeholder="Deixe em branco para utilizar a tabela modelo" open-direction="bottom"
                                     selectLabel="Enter para selecionar."
                                     deselectLabel="Enter para remover."
                                     :options="price_listOptions"
                                     :multiple="false"
                                     :searchable="true"
                                     :loading="isLoading"
                                     :preserve-search="true"
                                     :internal-search="false"
                                     :clear-on-select="true"
                                     :close-on-select="true"
                                     :max-height="450"
                                     :custom-label="codeWithNameLabel"
                                     :show-no-results="true" :hide-selected="false" @search-change="this.debouncedGetSearchPriceList">
                            <span slot="noOptions">Digite o nome ou o código da tabela desejada.</span>
                            <span slot="noResult">Nenhum resultado encontrado.</span>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <label class="control-label">Plano de contas</label>
                        <multiselect v-model="dentalPlan.account_plan" label="plan" track-by="id" placeholder="Plano de contas" open-direction="bottom"
                                     selectLabel="Enter para selecionar."
                                     deselectLabel="Enter para remover."
                                     :options="accountPlansProp"
                                     :multiple="false"
                                     :clear-on-select="true"
                                     :close-on-select="true"
                                     :max-height="450"
                                     :hide-selected="false">
                            <span slot="noOptions">Nenhum resultado encontrado.</span>
                            <span slot="noResult">Nenhum resultado encontrado.</span>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <btn @click="dentalPlanModal=false">Cancelar</btn>
                <btn type="primary" @click="saveDentalPlan"><i class="fa fa-save" aria-hidden="true"></i> {{okTextDentalPlanModal}}</btn>
            </div>
        </modal>

        <div class="panel panel-default">
            <div class="panel-heading">
                <div class="row" style="margin-bottom: -14px">
                    <div class='col-sm-3'>
                        <div class="form-group">
                            <btn type="info" @click="addDentalPlan"><i class="fa fa-plus" aria-hidden="true"></i> Novo Plano Dental</btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-default">
                    <div class="box-header with-border">
                        <i class="fa fa-stethoscope"></i>
                        <h3 class="box-title">Planos Dentais</h3>
                    </div>
                    <!-- /.box-header -->
                    <div class="box-body">
                        <datatable-component search-placeholder-prop="Buscar..." ref="dataTables" class="mt-3"
                                             :columns-prop="columns"
                                             url-prop="/dental-plans/get/all"
                                             :tableDataSendRequestProp="{}"
                                             default-order-prop="code">
                            <template v-slot:price_list="data">
                                {{ data.data.price_list ? data.data.price_list.code + ' | ' + data.data.price_list.name : 'TABELA MODELO | PARTICULAR' }}
                            </template>
                            <template v-slot:action="data">
                                <li class="m-1" @click="editDentalPlan(data.data)"><a href="javascript:void(0)" title="Editar"><i class="fa fa-edit" aria-hidden="true"></i> Alterar</a></li>
                                <li class="m-1" @click="deleteDentalPlan(data.data)"><a href="javascript:void(0)" title="Excluir"><i class="fa fa-trash" aria-hidden="true"></i> Excluir</a></li>
                            </template>
                        </datatable-component>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import {required} from "vuelidate/lib/validators";
    import Multiselect from "vue-multiselect";
    import DatatableComponent from "../datatable/datatable-component";

    export default {
        name: "DentalPlan",

        components: { Multiselect, DatatableComponent },

        props: {
            accountPlansProp: { type: Array, default: () => [] },
        },

        data() {
            return {
                isLoading: false,
                optionsToast: { timeout: 6000, position: 'topCenter' },
                dentalPlanModal: false,
                titleDentalPlanModal: null,
                okTextDentalPlanModal: null,

                price_listOptions: [],
                columns:[
                    { width: '5%', label: 'CÓDIGO.', name: 'code', type: 'String', sortable: true },
                    { width: '30%', label: 'NOME', name: 'name', type: 'String', sortable: true },
                    { width: '30%', label: 'TABELA', name: 'price_list', type: 'Slot', sortable: false },
                    { width: '30%', label: 'PLANO DE CONTAS', name: 'account_plan', type: 'ObjectMultiDimensional', key:'plan', sortable: false },
                    { width: '5%', label: 'AÇÃO', name: 'action', type: 'action', sortable: false },
                ],

                dentalPlan: {
                    id: null,
                    code: null,
                    name: null,
                    price_list: null,
                    account_plan: null
                }
            }
        },

        created() {
            // _.debounce é uma função fornecida pelo lodash para limitar a frequência que uma operação complexa pode ser executada.
            // Neste caso, queremos limitar a frequência com que acessamos a api, esperando que o usuário termine completamente
            // a digitação antes de realizar a chamada Ajax. Para aprender mais sobre a função _.debounce (e sua prima _.throttle),
            // visite: https://lodash.com/docs#debounce
            this.debouncedGetSearchPriceList = _.debounce(this.searchPriceList, 500)
        },

        validations: {
            dentalPlan:{
                code: { required },
                name: { required },
            },
        },

        methods: {
            resetDentalPlanModal() {
                this.dentalPlan = {
                    code: null,
                    name: null,
                    price_list: null,
                    account_plan: null
                }
            },

            addDentalPlan() {
                this.titleDentalPlanModal = 'Cadastrar novo plano',
                this.okTextDentalPlanModal = 'Cadastrar novo plano',
                this.dentalPlanModal= true
            },

            editDentalPlan(data) {
                console.log(data)
                Object.assign(this.dentalPlan, data);
                this.titleDentalPlanModal = 'Alterar plano dental'
                this.okTextDentalPlanModal = 'Alterar plano dental'
                this.dentalPlanModal= true
            },


            async saveDentalPlan() {
                if (this.$v.$invalid) {
                    this.$toast.warning('Por favor revise os campos obrigatórios', 'Aviso', this.optionsToast);
                    return false
                }

                try {
                    this.dentalPlanModal = false
                    let response = {}
                    if(this.dentalPlan.id)
                        response = await axios.put('/dental-plan',this.dentalPlan);
                    else
                        response = await axios.post('/dental-plan',this.dentalPlan);

                    if(response.data.type == 'success'){
                        this.$refs.dataTables.reload()
                        this.$toast.success(response.data.message, response.data.title, this.optionsToast);
                    } else if(response.data.type == 'warning'){
                        this.$toast.warning(response.data.message, response.data.title, this.optionsToast);
                    } else {
                        this.$toast.info(response.data.message, response.data.title, this.optionsToast);
                    }
                } catch (error) {
                    console.log(error);
                    if(error.response.status === 401 || error.response.status === 419){
                        this.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', this.optionsToast);
                    } else {
                        this.$toast.error(error.response.data.message, 'Erro', this.optionsToast);
                    }
                }
            },

            deleteDentalPlan(data) {
                let self = this;
                this.$toast.question('Tem certeza que deseja excluir este plano? Pacientes vinculados a este plano serão desvinculados!<br>Esta operação é irreversível!','ATENÇÃO',{
                    timeout: 20000,
                    close: false,
                    overlay: true,
                    toastOnce: true,
                    id: 'delete_' + data.id,
                    position: "center",
                    buttons: [
                        [
                            "<button><b>DELETAR PLANO DENTAL</b></button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                                axios.delete('/dental-plan/' + data.id)
                                    .then(response => {
                                        if(response.data.type == 'success'){
                                            self.$refs.dataTables.reload();
                                            self.$toast.success(response.data.message, response.data.title, self.optionsToast);
                                        } else if(response.data.type == 'warning'){
                                            self.$toast.warning(response.data.message, response.data.title, self.optionsToast);
                                        } else {
                                            self.$toast.info(response.data.message, response.data.title, self.optionsToast);
                                        }
                                    }).catch(error => {
                                    console.log(error);
                                    if(error.response.status === 401 || error.response.status === 419){
                                        self.$toast.warning('Sua sessão expirou. Por favor atualize a página.', 'AVISO', self.optionsToast);
                                    } else {
                                        self.$toast.error(error.response.data.message, 'Erro', self.optionsToast);
                                    }
                                })
                            },
                            true
                        ],
                        [
                            "<button>CANCELAR</button>",
                            function(instance, toast) {
                                instance.hide({ transitionOut: "fadeOut" }, toast);
                            }
                        ]
                    ],
                })
            },

            codeWithNameLabel ({ code, name }) {
                return `${code} | ${name}`
            },

            searchPriceList (query) {
                this.isLoading = true
                axios.post('/price/list/search', {'kw': query})
                    .then(function (response) {
                        this.price_listOptions = response.data
                        this.isLoading = false
                    }.bind(this))
                    .catch(function (error) {
                        console.log(error)
                    })
            },
        },
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .invalid{
        padding: 0px;
        border: 1px solid #dd4b39;
        border-radius: 5px;
    }
</style>